(function () {
  // Guarda un handler de scroll/resize por sección (clave = id del wrapper
  // #shopify-section-...) para poder quitarlo antes de reponer uno nuevo
  // cuando el theme editor recarga la sección (evita apilar listeners).
  var parallaxHandlers = {};

  // Igual que parallaxHandlers, pero para los bucles requestAnimationFrame
  // de los stickers "Pin while scrolling": guarda una función de parada por
  // sticker (no un id de rAF, porque el bucle se reprograma solo cada frame)
  // para poder detenerlos antes de reinicializar la sección.
  var stickerPinHandlers = {};

  function getSectionId(root) {
    var wrapper = root.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id : null;
  }

  function initTabs(root) {
    if (root.dataset.schoolLandingTabsInit === 'true') return;
    root.dataset.schoolLandingTabsInit = 'true';

    var tabs = root.querySelectorAll('.school-landing__tag');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panelId = tab.getAttribute('data-panel');
        var panel = root.querySelector('#' + panelId);
        if (!panel) return;

        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
        });
        root.querySelectorAll('.school-landing__panel').forEach(function (p) {
          p.hidden = true;
        });

        tab.setAttribute('aria-selected', 'true');
        panel.hidden = false;

        // Los puntos debajo de las bolas indican en cual esta el usuario
        // (y, al haber varios, que se puede seguir haciendo scroll).
        root.querySelectorAll('.school-landing__tag-dot').forEach(function (dot) {
          var isActive = dot.getAttribute('data-dot-for') === tab.id;
          dot.classList.toggle('school-landing__tag-dot--active', isActive);
        });
      });
    });
  }

  function initDots(root) {
    if (root.dataset.schoolLandingDotsInit === 'true') return;
    root.dataset.schoolLandingDotsInit = 'true';

    root.querySelectorAll('.school-landing__tag-dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var tab = document.getElementById(dot.getAttribute('data-dot-for'));
        // Reutiliza el click del tab (mismo cambio de panel, misma
        // actualizacion de aria-selected y del resto de puntos) en vez de
        // duplicar esa logica aqui.
        if (tab) tab.click();
      });
    });
  }

  function initLazyExtra(root) {
    var sentinels = root.querySelectorAll('.school-landing__load-sentinel');

    sentinels.forEach(function (sentinel) {
      if (sentinel.dataset.lazyExtraInit === 'true') return;
      sentinel.dataset.lazyExtraInit = 'true';

      var target = document.getElementById(sentinel.dataset.loadSentinelFor);
      if (!target) return;

      if (!('IntersectionObserver' in window)) {
        // Sin soporte para IntersectionObserver: se muestran directamente,
        // mejor eso que dejarlos ocultos para siempre.
        target.hidden = false;
        return;
      }

      // rootMargin negativo en bottom: el aviso llega un poco antes de que
      // el marcador toque literalmente el borde inferior de la pantalla,
      // asi la carga se nota menos como un "salto" al hacer scroll.
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          target.hidden = false;
          observer.disconnect();
        });
      }, { rootMargin: '0px 0px 200px 0px' });

      observer.observe(sentinel);
    });
  }

  function initParallax(root) {
    var sectionId = getSectionId(root);

    if (sectionId && parallaxHandlers[sectionId]) {
      window.removeEventListener('scroll', parallaxHandlers[sectionId]);
      window.removeEventListener('resize', parallaxHandlers[sectionId]);
      delete parallaxHandlers[sectionId];
    }

    if (root.getAttribute('data-parallax-enabled') !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var images = root.querySelectorAll('.school-landing__bg-image, .school-landing__hero-image--parallax');
    if (!images.length) return;

    var ticking = false;

    function update() {
      var sectionRect = root.getBoundingClientRect();
      images.forEach(function (img) {
        var speed = parseFloat(img.getAttribute('data-speed')) || 0.4;
        var offset = sectionRect.top * speed * -1;
        img.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    if (sectionId) parallaxHandlers[sectionId] = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initStickerPin(root) {
    var sectionId = getSectionId(root);

    if (sectionId && stickerPinHandlers[sectionId]) {
      stickerPinHandlers[sectionId].forEach(function (stop) {
        stop();
      });
      delete stickerPinHandlers[sectionId];
    }

    var stickers = root.querySelectorAll('.school-landing__sticker[data-pin-on-scroll="true"]');
    if (!stickers.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Referencia de "despegue": el banner de categorías de esta sección si
    // existe (settings.banner_image es opcional), o la sección entera si no.
    var hero = root.querySelector('.school-landing__hero-wrapper') || root;
    var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
    var isDesktop = window.matchMedia('(min-width: 750px)');
    // El footer se consulta una vez por (re)inicialización, no en cada
    // frame: barato y evita quedarnos con una referencia obsoleta si el
    // footer llega a re-renderizarse tras esta primera consulta.
    var footer = document.querySelector('.footer');
    var stoppers = [];

    stickers.forEach(function (el) {
      var originalStyle = el.getAttribute('style');
      var pinFromStart = el.dataset.pinFromStart === 'true';
      var triggerOffset = parseFloat(el.dataset.pinTriggerOffset) || 0;
      var pinnedTop = parseFloat(el.dataset.pinnedTop) || 0;
      var pinnedLeft = parseFloat(el.dataset.pinnedLeft) || 0;
      var pinnedWidth = parseInt(el.dataset.pinnedWidth, 10) || el.offsetWidth;
      var pinnedRotation = parseFloat(el.dataset.pinnedRotation) || 0;
      var pinnedOpacity = el.dataset.pinnedOpacity || '1';
      var pinned = false;
      var stopped = false;

      function pin() {
        el.style.position = 'fixed';
        el.style.top = pinnedTop + '%';
        el.style.left = pinnedLeft + '%';
        el.style.width = pinnedWidth + 'px';
        el.style.transform = 'rotate(' + pinnedRotation + 'deg)';
        el.style.opacity = pinnedOpacity;
        // Por debajo del header sticky de erickStore (z-index: 12) para no
        // tapar nunca el logo/nav/carrito si el comerciante deja el sticker
        // fijado cerca de la parte de arriba de la pantalla.
        el.style.zIndex = '10';
        el.style.transition = 'opacity 250ms ease';
        pinned = true;
      }

      function unpin() {
        el.setAttribute('style', originalStyle);
        pinned = false;
      }

      function update() {
        if (!isDesktop.matches) {
          if (pinned) { unpin(); }
          return;
        }

        var heroRect = hero.getBoundingClientRect();
        var shouldPin = pinFromStart || heroRect.bottom <= headerHeight + triggerOffset;
        if (shouldPin && !pinned) { pin(); }
        else if (!shouldPin && pinned) { unpin(); }

        if (pinned && footer) {
          var footerRect = footer.getBoundingClientRect();
          var shouldHide = footerRect.top < window.innerHeight;
          el.style.opacity = shouldHide ? '0' : pinnedOpacity;
          el.style.pointerEvents = shouldHide ? 'none' : '';
        }
      }

      function loop() {
        if (stopped) return;
        update();
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);

      stoppers.push(function () {
        stopped = true;
        if (pinned) { unpin(); }
      });
    });

    if (sectionId) stickerPinHandlers[sectionId] = stoppers;
  }

  function initSection(root) {
    initTabs(root);
    initDots(root);
    initLazyExtra(root);
    initParallax(root);
    initStickerPin(root);
  }

  function initAll() {
    document.querySelectorAll('.school-landing').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Al recargar UNA sección en el theme editor, re-inicializamos solo el
  // ".school-landing" de esa sección (si lo tiene), no todas las de la página.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.school-landing')
      : null;

    if (root) {
      initSection(root);
    } else {
      initAll();
    }
  });
})();
